import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities } from '@redux/entities'

import api from '@functions/api'

import type { TransactionTypeModel } from '@models/transactionType'
import type { AppDispatch } from '@redux/store'
import type {
  Action, ActionResult, EntityOptions, Errors,
} from '@redux/modules/types'

import { handleError } from '../utils'

const FETCH_REQUEST = 'realbase/transactionType/FETCH_REQUEST'
const FETCH_SUCCESS = 'realbase/transactionType/FETCH_SUCCESS'
const FETCH_FAILURE = 'realbase/transactionType/FETCH_FAILURE'

export type TransactionTypeModuleState = {
  errors: string[],
  loaded: boolean,
  loading: boolean,
}

const initialState: TransactionTypeModuleState = {
  errors: [],
  loaded: false,
  loading: false,
}

// Actions
export function fetchRequest(): Action{
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(): Action{
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors: Errors = []): Action{
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Action Creators
export function loadTransactionTypes(options: EntityOptions = {}){
  return (dispatch: AppDispatch): Promise<ActionResult> => {
    dispatch(fetchRequest())

    const promise = api('/transaction-types', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.TRANSACTION_TYPE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(
  state: TransactionTypeModuleState = initialState,
  action: Action = { type: '' },
): TransactionTypeModuleState {
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors || [],
      }
    default:
      return state
  }
}
